import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { motion, useScroll } from 'framer-motion';
import { Mountain, Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { scrollY } = useScroll();
  const { toast } = useToast();

  useEffect(() => {
    return scrollY.onChange(latest => {
      setIsScrolled(latest > 50);
    });
  }, [scrollY]);

  const showNotImplementedToast = () => {
    toast({
      title: "🚧 !",
      description: "! 🚀",
      duration: 3000
    });
  };

  const navItems = [
    { name: "Lomba", path: "/races" },
    { name: "Jadwal", path: "/schedule" },
    { name: "Kontak", path: "/contact" }
  ];

  return (
    <motion.header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || isOpen
          ? 'bg-black/60 backdrop-blur-sm'
          : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">

          {/* LOGO */}
          <Link to="/" className="flex items-center space-x-2">
            <Mountain className="h-8 w-8 text-orange-400 drop-shadow-[0_0_12px_rgba(255,140,0,0.9)]" />
            <span className="text-xl font-bold text-orange-400 drop-shadow-[0_0_10px_rgba(255,140,0,0.8)]">
              Banyumas Ultra
            </span>
          </Link>

          {/* MENU DESKTOP */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map(item => (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `transition-colors duration-200 font-medium
                   text-orange-300 hover:text-orange-400
                   ${isActive ? 'text-orange-400 drop-shadow-[0_0_8px_rgba(255,140,0,0.8)] font-semibold' : ''}`
                }
              >
                {item.name}
              </NavLink>
            ))}
          </nav>

          {/* RIGHT BUTTON */}
          <div className="flex items-center space-x-4">

            <a
              href="https://sobat.id/events/b-ultra"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="hidden sm:inline-flex bg-orange-500 hover:bg-orange-400 text-white font-bold shadow-[0_0_20px_rgba(255,140,0,0.7)]">
                Daftar Sekarang
              </Button>
            </a>

            <button
              onClick={() => setIsOpen(!isOpen)}
              className="md:hidden p-2 rounded-md text-orange-300 hover:text-orange-400 focus:outline-none"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>

          </div>
        </div>
      </div>

      {/* MOBILE MENU */}
      {isOpen && (
        <motion.div
          className="md:hidden bg-black/80 backdrop-blur-sm"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
        >
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navItems.map(item => (
              <NavLink
                key={item.name}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `block w-full text-left px-3 py-2 rounded-md text-base font-medium
                   text-orange-300 hover:text-orange-400
                   ${isActive ? 'bg-orange-500/20 text-orange-400' : ''}`
                }
              >
                {item.name}
              </NavLink>
            ))}

            <a
              href="https://sobat.id/events/b-ultra"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                onClick={() => setIsOpen(false)}
                className="w-full mt-2 bg-orange-500 hover:bg-orange-400 text-white font-bold"
              >
                Daftar Sekarang
              </Button>
            </a>

          </div>
        </motion.div>
      )}

    </motion.header>
  );
};

export default Header;